/**
 * Overlay badge mark used on earn/ad creatives (lower-left brand chip).
 *
 * Active default: stylized green 2Way arrow-"2" PNG (same mark as branding logo.png /
 * WordPress image overlays on https://2waymicropay.com/wp/test-this-image-link/).
 * Text SVG `/overlay-logo.svg` is only an onError fallback.
 *
 * To switch back to the Qix mark later, change ACTIVE_OVERLAY_BADGE_LOGO only:
 *   export const ACTIVE_OVERLAY_BADGE_LOGO = OVERLAY_BADGE_LOGO_QIX;
 */
export const OVERLAY_BADGE_LOGO_2WAY = '/overlay-logo.png';
/** Transparent Qix mark kept for a one-line switch-back. */
export const OVERLAY_BADGE_LOGO_QIX = '/qix-overlay-logo.png';
/** Last-resort glyph if PNGs fail to load. */
export const OVERLAY_BADGE_LOGO_2WAY_FALLBACK_SVG = '/overlay-logo.svg';

export const ACTIVE_OVERLAY_BADGE_LOGO = OVERLAY_BADGE_LOGO_2WAY;
